import React, { useState, useEffect } from 'react';
import { useDebounceCallback } from 'usehooks-ts';

import { Input, InputProps } from './';

interface DebouncedInputProps extends Omit<InputProps, 'onChange'> {
  onChange: (value: string) => void;
  delay?: number;
}

export function DebouncedInput({ value, onChange, delay = 1000, ...rest }: DebouncedInputProps) {
  const [searchValue, setSearchValue] = useState(value);
  const debouncedFn = useDebounceCallback(onChange, delay);

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  const handleSearchValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);
    debouncedFn(newSearchValue);
  };

  return <Input value={searchValue} onChange={handleSearchValueChange} {...rest} />;
}
